var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("van-nav-bar", {
        attrs: {
          "safe-area-inset-top": "",
          "left-arrow": "",
          title: "兑换记录",
          fixed: "",
        },
        on: {
          "click-left": function ($event) {
            return _vm.$router.back()
          },
        },
      }),
      _c(
        "div",
        { staticClass: "box-content", staticStyle: { "margin-top": "3.1rem" } },
        [
          _c(
            "div",
            { staticClass: "div-conter" },
            [
              _c(
                "van-list",
                {
                  attrs: {
                    finished: _vm.finished,
                    "finished-text": "没有更多了",
                  },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.loading,
                    callback: function ($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading",
                  },
                },
                _vm._l(_vm.list, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "van-hairline--bottom list-1" },
                    [
                      _c(
                        "van-row",
                        { staticClass: "row-1", attrs: { type: "flex" } },
                        [
                          _c("van-col", { staticClass: "header-1" }, [
                            _vm._v(" " + _vm._s(item.giftName) + " "),
                          ]),
                          _c(
                            "van-col",
                            { staticClass: "align-right-flex" },
                            [
                              _c(
                                "van-tag",
                                {
                                  attrs: { type: _vm.getVantType(item.status) },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getStatusDescription(item.status)
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        { staticClass: "row-1", attrs: { type: "flex" } },
                        [
                          _c("van-col", { staticClass: "body-1" }, [
                            _c("span", { staticClass: "header-1" }, [
                              _vm._v("兑换日期:"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DATE_TIME_FORMATTER.format(
                                    new Date(item.redeemDate)
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "van-col",
                            { staticClass: "body-1 align-right-flex" },
                            [_vm._v(" " + _vm._s(item.redeemPoint) + "积分 ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        { staticClass: "row-1", attrs: { type: "flex" } },
                        [
                          _c("van-col", { staticClass: "body-1 header-1" }, [
                            _vm._v(" 收货信息: "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        { staticClass: "row-1", attrs: { type: "flex" } },
                        [
                          _c("van-col", { staticClass: "body-1" }, [
                            _vm._v(" " + _vm._s(item.receiverName) + " "),
                          ]),
                          _c(
                            "van-col",
                            { staticClass: "body-1 align-right-flex" },
                            [_vm._v(" " + _vm._s(item.receiverContact) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        { staticClass: "row-2", attrs: { type: "flex" } },
                        [
                          _c("van-col", { staticClass: "body-1" }, [
                            _vm._v(" " + _vm._s(item.shippingAddress) + " "),
                          ]),
                          _vm.canBeCanceled(item.status)
                            ? _c(
                                "van-col",
                                { staticClass: "align-right-flex col-1" },
                                [
                                  _c(
                                    "van-button",
                                    {
                                      staticStyle: { width: "5rem" },
                                      attrs: {
                                        type: "info",
                                        size: "small",
                                        round: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.cancelRedemption(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(" 取消 "),
                                      _c("van-icon", {
                                        attrs: { name: "clear" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "navigateBtn" }, [
        _c(
          "div",
          { staticClass: "navigateBtn-d1" },
          [
            _c(
              "van-button",
              {
                attrs: { round: "", block: "", type: "info" },
                on: {
                  click: function ($event) {
                    return _vm.$router.back()
                  },
                },
              },
              [_vm._v("返回")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }